import React from 'react'
import Cta from 'src/components/Cta'
import HeroBanner from './sections/HeroBanner'
import Intro from './sections/Intro'
import Features from './sections/Features'
import Cases from './sections/Cases'
import Clients from './sections/Clients'
import './Home.sass'

const Home = () => {
  return (
    <div className="page" id="home">
      <HeroBanner />
      <Intro />
      <Features />
      <Cases />
      <Clients />
      <Cta />
    </div>
  )
}

export default Home
